import { PaymentTypeRecord } from '../../../../components/payments/payments.types';

/** The biggest `sort_order` the backend takes, a bigger one is a 400 */
export const PAYMENT_SORT_ORDER_MAX = 1_000_000;

/** A payment type or service as its table row has it: the order is text, as it is typed in the row */
export interface PaymentDirectoryRow {
  /** Empty for the record that is being created */
  id: string;
  name: string;
  sort_order: string;
  is_active: boolean;
}

/** The row of a record of either reference book */
export const toDirectoryRow = (record: PaymentTypeRecord): PaymentDirectoryRow => ({
  id: record.id,
  name: record.name,
  sort_order: String(record.sort_order),
  is_active: record.is_active,
});

/** A typed order: a whole number from 0; null when it is not one */
export function parseSortOrder(text: string): number | null {
  const digits = text.trim();
  if (!/^\d+$/.test(digits)) return null;

  const order = Number(digits);
  return order <= PAYMENT_SORT_ORDER_MAX ? order : null;
}

/** Translation key of what is wrong with the typed order; a new record may have none, it goes last */
export function getSortOrderError(row: Pick<PaymentDirectoryRow, 'id' | 'sort_order'>): string | null {
  if (!row.id && !row.sort_order.trim()) return null;

  return parseSortOrder(row.sort_order) === null ? 'board_payments.directories.order_invalid' : null;
}
